import { InfoCardProvider } from './hooks/useInfoCard';

import { InfoCardContainer } from './handles/InfoCardContainer';
import { InfoCardHeadline } from './handles/InfoCardHeadline';
import { InfoCardTextContainer } from './handles/InfoCardTextContainer';
import { InfoCardImageContainer } from './handles/InfoCardImageContainer';
import { InfoCardSubhead } from './handles/InfoCardSubhead';
import { InfoCardCallActionContainer } from './handles/InfoCardCallActionContainer';
import { InfoCardProps } from './@types/InfoCardProps';

export function InfoCard(props: InfoCardProps) {
	return (
		<InfoCardProvider {...props}>
			<InfoCardContainer>
				<InfoCardTextContainer>
					<InfoCardHeadline />
					<InfoCardSubhead />
					<InfoCardCallActionContainer />
				</InfoCardTextContainer>

				<InfoCardImageContainer />
			</InfoCardContainer>
		</InfoCardProvider>
	);
}
